const hasPhones = (phones) => {
  const formatE164 = (phone) => {
    return `+${phone.countryCode}${phone.phoneNumber}`;
  };
  const formatUs = (phone) => {
    return `(${phone.phoneNumber.slice(0, 3)}) ${phone.phoneNumber.slice(
      3,
      6,
    )}-${phone.phoneNumber.slice(-4)}`;
  };
  const format = (phone) => {
    return phone.countryCode !== '1' ? formatE164(phone) : formatUs(phone);
  };
  return {
    getDefaultPhone() {
      const index = phones.findIndex(phone => phone.isDefault);
      return index === -1 ? '' : phones[index].phoneNumber;
    },
    getDefaultPhoneFormatted() {
      const index = phones.findIndex(phone => phone.isDefault);
      return index === -1 || phones[index].phoneNumber === '' ? '' : format(phones[index]);
    },
    getFormattedPhones() {
      return phones.map((phone) => {
        const formatted = {
          label: phone.label,
          phoneNumber: format(phone),
        };
        if (phone.isDefault) {
          formatted.isDefault = true;
        }
        return formatted;
      });
    },
    getPhonesWithAdded(phone) {
      if (!phones.length) {
        return [{ ...phone, isDefault: true }];
      }
      return [{ ...phone, isDefault: false }, ...phones];
    },
    getPhonesWithDefault(defaultIndex) {
      return phones.map((phone, index) => {
        if (index === defaultIndex) {
          return { ...phone, isDefault: true };
        }
        return { ...phone, isDefault: false };
      });
    },
    getPhonesWithDeleted(index) {
      const withDeleted = [...phones];
      withDeleted.splice(index, 1);
      return withDeleted;
    },
    getPhonesWithUpdated(index, phone) {
      const withUpdated = [...phones];
      withUpdated.splice(index, 1, phone);
      return withUpdated;
    },
  };
};

export default hasPhones;
